import React from 'react';
import Grid from '@mui/material/Grid';
import {Theme} from './Theme';
import {Dataset,Countset,Owner,OwnerRoom} from './Inc';

export class Tools {
    static getWindowSize = ()=>{
        let wd = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        w = wd.innerWidth || e.clientWidth || g.clientWidth,
        h = wd.innerHeight|| e.clientHeight|| g.clientHeight;
    
        return {
            width: w,
            height: h
        }
    }
    static isWidthDown = (num:number)=>{
        const size = Tools.getWindowSize();
        if( size.width<num ){
            return true;
        }
        return false;
    }
    static getModalStyle = ()=> {
        const top = 50;
        const left = 50;
      
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }
    static getModalSearchStyle = ()=>{
        const size = Tools.getModalSize();
        return {
            width: `${size.width}px`,
            height: `${size.height}px`,
            backgroundColor: `white`,
        };
    }
    static getModalConfirmStyle = ()=>{
        const size = Tools.getModalSize();
        return {
            width: `${size.width}px`,
            height: `${size.height}px`,
        };
    }
    static getModalEditorStyle = ()=>{
        const size = Tools.getModalSize(true);
        return {
            width: `${size.width}px`,
            height: `${size.height}px`,
        };
    }
    static getModalSize = (wide?:boolean)=>{
        const size = Tools.getWindowSize();
        let w = 800;
        let max = 0.9;
        if( wide ){
            w = 960;
            max = 0.95;
        }
        if( size.width<800 ){
            w = size.width;
            max = 1.0;
        }
        let h = Math.floor(size.height * max);
        if( h>800 && !wide ){
            h = 800;
        }
        //console.log(w,h);
        return {
            width: w,
            height: h,
        }
    }
    static decodeQueryStrings(str:string){
        const sp1 = str.replace("?","").split("&");
        let data:{[key: string]: string;} = {};
        for(let i=0 ; i<sp1.length ; i++){
            const sp2 = sp1[i].split("=");
            data[ sp2[0] ] = sp2[1];
        }
        return data;
    }
    static pager = (param:any,func:any)=>{
        if(!param){
            return (null);
        }
        const style = {
            backgroundColor: "white",
            border:"1px solid silver",
            width:"3em",
            padding:"0.25em 0",
            margin:"0 0.1em",
            cursor:"pointer",
        }
        const style_current = {
            backgroundColor: Theme.palette.primary.main,
            border:`1px solid ${Theme.palette.primary.main}`,
            width:"3em",
            padding:"0.25em 0",
            margin:"0 0.1em",
            color:"white",
        }
        let tmp = [];
        if( param.start>param.min_page ){
            tmp.push(
                (<button style={style} key="pgfirst" onClick={()=>func(param.min_page)}>&lt;</button>)
            );
        }
        for( let i=param.start ; i<=param.end ; i++ ){
            const key = "pg"+i;
            if( i!==parseInt(param.current) ){
                tmp.push(
                    (<button style={style} key={key} onClick={()=>func(i)}>{i}</button>)
                );
            } else {
                tmp.push(
                    (<button style={style_current} key={key} onClick={()=>func(i)}>{i}</button>)
                );
            }
        }
        if( param.end<param.max_page ){
            tmp.push(
                (<button style={style} key="pglast" onClick={()=>func(param.max_page)}>&gt;</button>)
            );
        }

        return (
            <Grid container spacing={2}>
                <Grid item sm={10} xs={12}>{tmp}</Grid>
                <Grid item sm={2} xs={12} style={{textAlign:"right"}}><span style={{borderBottom:"1px solid silver"}}>{param.count}件</span></Grid>
            </Grid>
        );
    }
    static getLabel = (list:Dataset[],id:string) => {
        for( let i=0 ; i<list.length ; i++ ){
            if( list[i].id===id ){
                return list[i].label;
            }
        }
        return "";
    }
    static zeroPadding = (num:string,length:number)=>{
        return ('0000000000' + num).slice(-length);
    }
    static comma = (num:number) =>{
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    static joinTime = (h:string,m:string)=>{
        if( h!=="" && m!=="" ){
            return Tools.zeroPadding(h,2)+":"+Tools.zeroPadding(m,2);
        }
        return "";
    }
	static stripTags = (text:string) =>{
		return text.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
	}
	static empty = (text:string,caption?:string) => {
		if( text!==null && text!=="" ){
			return text;
		}
		if( caption ){
			return (<span className='emptyText'>{caption}</span>);	
		}
		return (<span className='emptyText'>なし</span>);
	}
    static convOwner = (base:any,isLogined:boolean)=>{
        let owner:Owner = {
            owner_id: parseInt(base.owner_id),
			switch_id: parseInt(base.switch_id),
			img_id: parseInt(base.img_id),
            owner_name: base.owner_name,
            customer: base.customer,
            isLogined: isLogined,
            high_flag: base.high_flag,
            review_flag: base.review_flag,
            status: base.status,
        }
        return owner;
    }
    static getSelectYears = ()=>{
        let years:Dataset[] = [];
        const dt = new Date();
        const current = dt.getFullYear();
        for( let year=current ; year>=2005 ; year-- ){
            years.push({
                id: String(year),
                label: String(year)+"年",
            })
        }
        return years;
    }
    static getSelectMonths = ()=>{
        let months:Dataset[] = [];
        for( let month=1 ; month<=12 ; month++ ){
            months.push({
                id: String(month),
                label: String(month)+"月",
            })
        }
        return months;
    }
    static getStoreUrl = (item_id:number)=>{
		let url = process.env.REACT_APP_STOREURL + "/i" + item_id + ".html"; 
        return url;
    }
    static getStoreImg = (owner_id:number,img_id:number,thumb:boolean)=>{
        let path = process.env.REACT_APP_STOREURL + "/img/owner/"+String(owner_id)+"/";
        if( thumb ){
            path = path + "thumb/";
        }
        path = path + String(img_id)+".jpg";
        return path;
    }
    static getStoreSecretImg = (owner_id:number,img_id:number,secret:string,thumb:boolean)=>{
        let path = process.env.REACT_APP_STOREURL + "/img/owner/"+String(owner_id)+"/"+secret+"/";
        if( thumb ){
            path = path + "thumb/";
        }
        path = path + String(img_id)+".jpg";
        return path;
    }
    static getKbinImg = (kbin_id:number,file_name:string)=>{
        //console.log("process",process.env);
        return process.env.REACT_APP_CDNURL + "/img/default/kbin/"+String(kbin_id)+"/"+file_name;
    }
    static toHan = (strVal:string)=>{
        // 半角変換
        var halfVal = strVal.replace(/[！-～]/g,
            function( tmpStr ) {
            // 文字コードをシフト
            return String.fromCharCode( tmpStr.charCodeAt(0) - 0xFEE0 );
            }
        );
        
        // 文字コードシフトで対応できない文字の変換
        return halfVal.replace(/”/g, "\"")
            .replace(/’/g, "'")
            .replace(/‘/g, "`")
            .replace(/￥/g, "\\")
            .replace(/　/g, " ")
            .replace(/〜/g, "~");
    }
    // 数字以外は除去して、半角数字に変換する
    static toNumber = (numVal:string)=>{
        numVal = Tools.toHan(numVal);
        //console.log("toNumber",numVal);
        if( numVal==="" ){
            return "";
        }
        const pattern = /[^\d.-]/g;
        let result = numVal.replace(pattern, "");
        if( result==="." || result==="-." || result==="-0." ){
            return "0";
        }
        if( result==="-" ){
            return "0";
        }
        if( result==="." || result==="0." ){
            return "0";
        }
        if( result==="-" || result==="-0" ){
            return "0";
        }
        return result;
    }
    static isNumber = (numVal:string)=>{
        const pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
        return pattern.test(numVal);
    }
    static colorLabel = (type:string,id:number|string,text:string|undefined)=>{
        if(!text){
            return (null);
        }
        const cl = "cl cl-" + type + id;
        return (
            <span className={cl}>{text}</span>
        )
    }
    static colorOneLabel = (type:string,id:number|string,text:string|undefined)=>{
        if(!text){
            return (null);
        }
        const cl = "cl cl-" + type + id;
        return (
            <span className={cl} style={{padding:'0.1em 0.5em'}}>{text}</span>
        )
    }
    static treatPhotos = (photo_ids:number[],id:string,src:string,imgs:{ [key: string]: string; },max:number)=>{
        let num = photo_ids.length;
        const match = id.match(/(\D+)(\d+)$/);
        let baseId = id, index = 0;
        if (match) {
            baseId = match[1];
            index = parseInt(match[2]);
        } else {
            index = parseInt(id.replace(/\D/g, ""));
        }

        if (index===num && src && src!=="" && num < max) {
            photo_ids = [...photo_ids, 0];
            num++;
        }
        if( !src ){
            photo_ids[index-1] = 0;
        }
        let m = 0;
        for (let i = num; i > 0; i--) {
            const key = baseId + i;
            if ((imgs[key] && imgs[key] !== "") || photo_ids[i-1] !== 0) {
                m = i + 1;
                break;
            }
        }
        if (num-m > 0 && m > 0) {
            photo_ids = photo_ids.slice(0, m);
        } else if( m===0 && photo_ids[0] === 0) {
            photo_ids = [0];
        }
        return photo_ids;
    }
    static formatDate = (dateStr:string)=>{
        if( dateStr.length!==8 ){
            return dateStr;
        }
        return dateStr.substr(0,4)+"-"+dateStr.substr(4,2)+"-"+dateStr.substr(6,2);
    }

    static toCatCounts(list: any[]): Countset[] {
        // list をそのまま Countset[] に変換
        return list.map((cat) => ({
            id: cat.cat_type_id,
            name: cat.cat_type_name ?? "",
            value: cat.ct,
        }));
    }

    static toOwnerRooms(list: any[]): OwnerRoom[] {
        // list をそのまま OwnerRoom[] に変換
        return list.map((room) => ({
            owner_id: Number(room.owner_id),
            owner_name: room.owner_name,
            company_name: room.company_name,
            room_name: room.room_name,
            img_id: Number(room.img_id),
            dep_b: Number(room.dep_b),
            dep_f: Number(room.dep_f),
            dep_r: Number(room.dep_r),
            cat_types: room.cat_types,
            status: room.status,
        }));
    }
}